export default function ngLoadRoutes() {/**
 *    	APP ROUTES ES6 MODULE EXPORT
 *    	this file starts with the main ui-router route hierarchy
 * 		contains the main routes in dependency order for: espui, startup, login, home page, about
 * 		Grunt will append feature routes to the bottom of this file, look in each feature folder for a file ending ".routes.js"
 *
 
 type routeInfoType = {
	 title: string
};

type routeViewsItemInfoType = {
	controller: string,
	templateUrl: string
};

type routeViewsItemType = {
	name: string,
	entry: routeViewsItemInfoType
};

export interface IRouteItemType {
	parent?: string;
	abstract?: boolean;
	skipAuth?: boolean;
	name: string;
	url: string;
	routeInfo?: routeInfoType;
	views: routeViewsItemType[];
};
*/

// below line is inserted by Grunt, here for reference only
// export default function loadNgRoutes() {',
var routes = [];

/**
 * 		MAIN ESPUI APP LAYOUT
 */
routes.push({
	name: 'espui',
	abstract: true,
	views: {
		"appMsgbox": {
			controller: 'MsgBoxController as vmMsgbox',
			templateUrl: 'home/layout/ui/msgbox.tpl.html'
		},
		"appHeader": {
			controller: 'HeaderController as vmHeader',
			// controller: function($scope) {
			// 	console.log('header route controller');
			// },
			templateUrl: 'home/layout/ui/header.tpl.html'
		},
		"content": {},
		"appFooter": {
			controller: 'FooterController as vmFooter',
			templateUrl: 'home/layout/ui/footer.tpl.html'
		}
	}
});


/**
 * 		START UP / LOGIN / HOME PAGE
 */
routes.push({
	name: 'startup',
	parent: 'espui',
	skipAuth: true,
	url: '/startup',
	routeInfo: {
		title: 'Start Up'
	},
	views: {
		"content@": {
			controller: 'StartUpController as vm',
			templateUrl: 'home/startup/startup.tpl.html'
		}
	}
});

routes.push({
	name: 'login',
	parent: 'espui',
	skipAuth: true,
	url: '/login',
	routeInfo: {
		icon: 'icon-security',
		title: 'Login'
	},
	views: {
		"content@": {
			controller: 'LoginController as vm',
			templateUrl: 'home/login/login.tpl.html'
		}
	},
	params: {
		reason: null,
		token: null
	}
});


routes.push({
	name: 'home',
	parent: 'espui',
	skipAuth: false,
	url: '/home',
	routeInfo: {
		title: 'Dashboard'
	},
	views: {
		"content@": {
			controller: 'HomeController as vm',
			templateUrl: 'home/home.tpl.html'
		}
	}
});


/**
 * 		ABOUT - moved to react v2
 */


/**
 * 	OPS
 */
 routes.push({
	name: 'ops',
	parent: 'espui',
	abstract: true,
	url: '/operations',
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main.flex.tpl.html'
		}
	}
});

/**
 * 	ADMIN
 */
routes.push({
	name: 'admin',
	parent: 'espui',
	abstract: true,
	url: '/admin'
});


// Grunt will inject all route definitions below this line and wrap an ES6 module around the code
// }
 
 routes.push({
	name: 'ops.npi',
	url: '/npi',
	routeInfo: {
		icon: 'sprite-ops',
		title: 'NPIs'
	},
	params: {
		CE: null
	},
	controller: 'NpiCtl as vm',
	templateUrl: 'html/ops/npi/ui/npi.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.transform',
	url: '/mapping',
	routeInfo: {
		icon: 'sprite-mapping',
		title: 'Mapping'
	},
	params: {
		rxid: null,
		tab: null,
		ndc: null,
		transid: null
	},
	controller: 'TransformCtl as vm',
	templateUrl: 'html/ops/transform/ui/transform.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.accum',
	url: '/accumulation',
	routeInfo: {
		icon: 'sprite-ndc-accum',
		title: 'Accumulation'
	},
	controller: 'AccumListCtl as vm',
	templateUrl: 'html/ops/accum/ui/list.html?v=' + window.verityEspVersion,
	params: {
		noCache: null // if true, this route will NOT use the app route params cache
	}
});

routes.push({
	name: 'ops.accum.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});

routes.push({
	name: 'ops.accum-detail',
	url: '/accumdetail',
	routeInfo: {
		icon: 'sprite-ndc-accum',
		title: 'Accumulation Detail',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'ops.accum',
			routeData: null,
			msg: 'Return to Accumulation List'
		}
	},
	controller: 'AccumDetailCtl as vm',
	templateUrl: 'html/ops/accum/ui/detail.html?v=' + window.verityEspVersion,
	params: {
		Id: null,
		CE: null,
		RX: null,
		ShareGroup: null,
		CanEdit: null,
		breadcrumb: false
	}
});

routes.push({
	name: 'ops.accum-detail.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});

routes.push({
	name: 'ops.match',
	url: '/match',
	routeInfo: {
		icon: 'sprite-match',
		title: 'Match List'
	},
	controller: 'MatchListCtl as vm',
	templateUrl: 'html/ops/match/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.match-suspect',
	url: '/matchsuspect',
	routeInfo: {
		icon: 'sprite-match',
		title: 'Match Suspect',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'ops.match',
			msg: 'Return to Suspects List'
		}
	},
	controller: 'MatchSuspectCtl as vm',
	templateUrl: 'html/ops/match/ui/suspect.html?v=' + window.verityEspVersion,
	params: {
		Items: null,
		Idx: null
	}
});

routes.push({
	name: 'ops.match.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});


routes.push({
	name: 'ops.catalogs',
	url: '/catalogs',
	routeInfo: {
		icon: 'sprite-ndc-accum',
		title: 'Catalogs'
	},
	controller: 'CatalogsListCtl as vm',
	templateUrl: 'html/ops/catalogs/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.catalogs.aff',
	url: '/catalogsaff',
	routeInfo: {
		icon: 'sprite-ndc-accum',
		title: 'Catalogs'
	},
	controller: 'CatalogsListCtl as vm',
	templateUrl: 'html/ops/catalogs/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.catalogs.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});

routes.push({
	name: 'ops.splittrans',
	url: '/splittrans',
	routeInfo: {
		icon: 'sprite-orders-split',
		title: 'Split Transactions'
	},
	controller: 'SplitTransListCtl as vm',
	templateUrl: 'html/ops/splittrans/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.visits',
	url: '/encounters',
	routeInfo: {
		icon: 'sprite-ce',
		title: 'Encounters'
	},
	controller: 'VisitsListCtl as vm',
	templateUrl: 'html/ops/visits/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.visits-create',
	url: '/encounterscreate',
	routeInfo: {
		icon: 'sprite-ce',
		title: 'Create Encounter',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'ops.visits',
			routeData: null,
			msg: 'Return to Encounter List'
		}
	},
	controller: 'VisitsEditCtl as vm',
	templateUrl: 'html/ops/visits/ui/edit.html?v=' + window.verityEspVersion,
	params: {
		CE: null
	}
});

routes.push({
	name: 'ops.claims',
	url: '/claims',
	routeInfo: {
		icon: 'sprite-rx',
		title: 'Claims'
	},
	controller: 'ClaimsListCtl as vm',
	templateUrl: 'html/ops/claims/ui/list.html?v=' + window.verityEspVersion,
	params: {
		dispid: null,
		rx: null
	}
});

routes.push({
	name: 'ops.claims.detail',
	url: '',
	routeInfo: null,
	views: {
		"claimDetailView": {
			controller: 'ClaimsDetailCtl as vm',
			templateUrl: 'html/ops/claims/ui/detail.html?v=' + window.verityEspVersion
		}
	},
	params: {
		id: null,
		claim: null,
		breadcrumb: false
	}
});


routes.push({
	name: 'ops.claims.visit-search',
	url: '',
	routeInfo: null,
	views: {
		"visitsSearchView": {
			controller: 'VisitsListCtl as vm',
			templateUrl: 'html/ops/visits/ui/list.html?v=' + window.verityEspVersion
		}
	},
	params: {
		MatchAffs: null,
		DateOfBirth: null,
		LastName: null,
	}
});

routes.push({
	name: 'ops.claims.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});

routes.push({
	name: 'ops.locations',
	url: '/locations',
	routeInfo: {
		icon: 'sprite-ce',
		title: 'Facility Locations'
	},
	controller: 'LocationsCtl as vm',
	templateUrl: 'html/ops/locations/ui/locations.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.customitem',
	url: '/customitem',
	routeInfo: {
		icon: 'sprite-rx',
		title: 'Custom NDCs'
	},
	controller: 'WacNeutCustomItemCtl as vm',
	templateUrl: 'html/ops/customitem/ui/customitem.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.vcentral',
	url: '/vcentral',
	routeInfo: {
		icon: 'sprite-rx',
		title: 'VCentral'
	},
	controller: 'VCentralCtl as vm',
	templateUrl: 'html/ops/vcentral/ui/vcentral.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.cashcard-member',
	url: '/carecard',
	routeInfo: {
		icon: 'sprite-about-corp',
		title: 'Care Card'
	},
	controller: 'CashCardMemberListCtl as vm',
	templateUrl: 'html/ops/cashcard/ui/member.list.html?v=' + window.verityEspVersion,
	params: {
		noCache: null // if true, this route will NOT use the app route params cache
	}
});

routes.push({
	name: 'ops.cashcard-member-create',
	url: '/carecard-create',
	routeInfo: {
		icon: 'sprite-about-corp',
		title: 'Create Member',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'ops.cashcard-member',
			routeData: null,
			msg: 'Return to Members List'
		}
	},
	controller: 'CashCardMemberEditCtl as vm',
	templateUrl: 'html/ops/cashcard/ui/member.edit.html?v=' + window.verityEspVersion,
	params: {
		Id: null,
		CE: null
	}
});

routes.push({
	name: 'ops.cashcard-member-edit',
	url: '/carecard-edit',
	routeInfo: {
		icon: 'sprite-about-corp',
		title: 'Edit Member',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'ops.cashcard-member',
			routeData: null,
			msg: 'Return to Members List'
		}
	},
	controller: 'CashCardMemberEditCtl as vm',
	templateUrl: 'html/ops/cashcard/ui/member.edit.html?v=' + window.verityEspVersion,
	params: {
		Id: null,
		CE: null
	}
});

routes.push({
	name: 'ops.referral',
	url: '/referral',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-ops' : 'icon-ops',
		title: 'Referral Capture',
		bkgHeight: '0rows'
	},
	controller: 'ReferralListCtl as vm',
	templateUrl: 'html/ops/referral/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.referral.detail',
	url: '/detail',
	routeInfo: null,
	views: {
		"referralDetailView": {
			controller: 'ReferralDetailCtl as vm',
			templateUrl: 'html/ops/referral/ui/detail.html?v=' + window.verityEspVersion
		}
	},
	params: {
		Items: null,
		Idx: null
	}
});

routes.push({
	name: 'ops.referral.detail.docs',
	url: '',
	routeInfo: null,
	views: {
		"referralDetailDocsView": {
			controller: 'ReferralDocsCtl as vm',
			templateUrl: 'html/ops/referral/ui/docs.html?v=' + window.verityEspVersion
		}
	},
	params: {
		Type: null,
		CE: null,
		RX: null,
		DispId: null,
		Docs: null
	}
});

routes.push({
	name: 'ops.referral.docs',
	url: '/docs',
	routeInfo: null,
	views: {
		"referralDocsView": {
			controller: 'ReferralDocsCtl as vm',
			templateUrl: 'html/ops/referral/ui/docs.html?v=' + window.verityEspVersion
		}
	},
	params: {
		Docs: null,
		CE: null,
		RX: null,
		ReferralCE: null
	}
});

routes.push({
	name: 'ops.ndclist',
	url: '/ndclist',
	routeInfo: {
		icon: 'sprite-ndc-accum',
		title: 'NDC List'
	},
	controller: 'NdcListCtl as vm',
	templateUrl: 'html/ops/ndc/ui/ndc.main.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'ops.ndclist.edit',
	url: '/edit',
	routeInfo: null,
	views: {
		"ndcMainEditView": {
			controller: 'NdcMainEditCtl as vm',
			templateUrl: 'html/ops/ndc/ui/ndc.edit.html?v=' + window.verityEspVersion
		}
	},
	params: {
		ListKey: null, // List Type
		EntityId: null,
		CE: null,
		RX: null,
		VEN: null,
		VenTitle: null,
		CeVerityPrimary:null
	}
});

routes.push({
	name: 'ops.pricevalidation',
	url: '/pricevalidation',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-orders-review' : 'icon-orders-review',
		title: 'Contract Price Validation',
		bkgHeight: '0rows'
	},
	controller: 'PriceListCtl as vm',
	templateUrl: 'html/ops/price/ui/list.html?v=' + window.verityEspVersion
});
 
 
routes.push({
	name: 'admin.bulkedit',
	abstract: true,
	url: '/bulkedit',
	routeInfo: {
		icon: 'icon-edit',
		title: 'Bulk Edit List'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main' + window.espuiPrefs.skin + '.tpl.html'
		}
	}
});

routes.push({
	name: 'admin.bulkedit.list',
	url: '',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-edit' : 'icon-edit',
		title: 'Bulk Edit List',
		bkgHeight: '0rows'
	},
	controller: 'AdminBulkEditCtl as vm',
	templateUrl: 'html/admin/bulkedit/ui/bulkedit.list.html?v=' + window.verityEspVersion
}); 
 /**
 * 	CE ROUTES
 *  see app.routes.js for more detail
 */

routes.push({
	name: 'admin.ce',
	abstract: true,
	url: '/ce',
	routeInfo: {
		icon: 'icon-ce',
		title: 'Facility List'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main' + window.espuiPrefs.skin + '.tpl.html'
		}
	},
	params: {
		CE: null
	}
});

routes.push({
	name: 'admin.ce.list',
	url: '/',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-ce' : 'icon-ce',
		title: 'Facility List',
		bkgHeight: '0rows'
	},
	controller: 'CeListCtl as vm',
	templateUrl: 'html/admin/ce/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.ce.create',
	url: '/create',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-ce' : 'icon-ce',
		title: 'New Facility',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'admin.ce.list',
			msg: 'Return to Facility List'
		}
	},
	controller: 'CeEditCtl as vm',
	templateUrl: 'html/admin/ce/ui/edit.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.ce.edit',
	url: '/update',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-ce' : 'icon-ce',
		title: 'Update Facility',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'admin.ce.list',
			msg: 'Return to Facility List'
		}
	},
	controller: 'CeEditCtl as vm',
	templateUrl: 'html/admin/ce/ui/edit.html?v=' + window.verityEspVersion,
	params: {
		CE: null
	}
});

routes.push({
	name: 'admin.ce.edit.affs',
	url: '',
	routeInfo: null,
	views: {
		"affsChildView": {
			controller: 'AffsListCtl as vm',
			templateUrl: 'html/admin/affiliates/ui/aff.list.html?v=' + window.verityEspVersion
		}
	},
	params: {
		ViewType: 'CE',
		CE: null,
		RX: null
	}
});

routes.push({
	name: 'admin.ce.edit.affs-detail',
	url: '',
	routeInfo: null,
	views: {
		"affsChildView": {
			controller: 'AffsDetailCtl as vm',
			templateUrl: 'html/admin/affiliates/ui/aff.detail.html?v=' + window.verityEspVersion
		}
	},
	params: {
		ViewType: null,
		CE: null,
		RX: null
	}
});

routes.push({
	name: 'admin.ce.edit.npi',
	url: '',
	routeInfo: null,
	views: {
		"npiListView": {
			controller: 'NpiCtl as vm',
			templateUrl: 'html/ops/npi/ui/npi.html?v=' + window.verityEspVersion
		}
	},
	params: {
		CE: null
	}
});

routes.push({
	name: 'admin.ce.edit.locations',
	url: '',
	routeInfo: null,
	views: {
		"locationsListView": {
			controller: 'LocationsCtl as vm',
			templateUrl: 'html/ops/locations/ui/locations.html?v=' + window.verityEspVersion
		}
	},
	params: {
		CE: null
	}
});

routes.push({
	name: 'admin.ce.edit.adt',
	url: '',
	routeInfo: null,
	views: {
		"adtEditView": {
			controller: 'AdtEditCtl as vm',
			templateUrl: 'html/admin/ce/ui/adt.main.html?v=' + window.verityEspVersion
		}
	},
	params: {
		CE: null
	}
});

routes.push({
	name: 'admin.ce.edit.vcentral',
	url: '',
	routeInfo: null,
	views: {
		"vcentralView": {
			controller: 'VCentralCtl as vm',
			templateUrl: 'html/ops/vcentral/ui/vcentral.html?v=' + window.verityEspVersion
		}
	},
	params: {
		CE: null
	}
});
 
 routes.push({
	name: 'admin.claimfed',
	abstract: true,
	url: '/claimfed',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-mapping' : 'icon-mapping',
		title: 'claimfed'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main' + window.espuiPrefs.skin + '.tpl.html'
		}
	},
});

routes.push({
	name: 'admin.claimfed.list',
	url: '/list',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-mapping' : 'icon-mapping',
		title: 'Carepath Claims Federation',
		bkgHeight: '0rows'
	},
	controller: 'ClaimFedListCtl as vm',
	templateUrl: 'html/admin/claimfed/ui/list.html?v=' + window.verityEspVersion
}); 
 routes.push({
	name: 'admin.datamgr',
	abstract: true,
	url: '/datamanager',
	routeInfo: {
		icon: 'icon-datamgr',
		title: 'Data Manager'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/mainB.tpl.html'
		}
	}
});

routes.push({
	name: 'admin.datamgr.main',
	url: '/',
	routeInfo: {
		icon: 'sprite-maint',
		title: 'Data Manager',
		bkgHeight: '0rows'
	},
	controller: 'DatamgrCtl as vm',
	templateUrl: 'html/admin/datamgr/ui/main.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.datamgr.main.feeds-detail',
	url: '',
	routeInfo: null,
	views: {
		"feedDetailView": {
			controller: 'FeedsDetailCtl as vm',
			templateUrl: 'html/ops/feeds/ui/detail.html?v=' + window.verityEspVersion
		}
	},
	params: {
		Id: null
	}
}); 
 routes.push({
	name: 'admin.groups',
	abstract: true,
	url: '/groups',
	routeInfo: {
		icon: 'icon-about-corp',
		title: 'Group List'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main' + window.espuiPrefs.skin + '.tpl.html'
		}
	}
});

routes.push({
	name: 'admin.groups.list',
	url: '/',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-about-corp' : 'icon-about-corp',
		title: 'Group List',
		bkgHeight: '0rows'
	},
	controller: 'GroupsListCtl as vm',
	templateUrl: 'html/admin/groups/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.groups.create',
	url: '/create',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-about-corp' : 'icon-about-corp',
		title: 'New Group',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'admin.groups.list',
			msg: 'Return to Group List'
		}
	},
	controller: 'GroupsEditCtl as vm',
	templateUrl: 'html/admin/groups/ui/edit.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.groups.edit',
	url: '/update',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-about-corp' : 'icon-about-corp',
		title: 'Update Group',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'admin.groups.list',
			msg: 'Return to Group List'
		}
	},
	controller: 'GroupsEditCtl as vm',
	templateUrl: 'html/admin/groups/ui/edit.html?v=' + window.verityEspVersion,
	params: {
		Id: null
	}
});
 
 
routes.push({
	name: 'admin.rx',
	abstract: true,
	url: '/rx',
	routeInfo: {
		icon: 'icon-ce',
		title: 'Pharmacy List'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main' + window.espuiPrefs.skin + '.tpl.html'
		}
	}
});

routes.push({
	name: 'admin.rx.list',
	url: '/',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-rx' : 'icon-rx',
		title: 'Pharmacy List',
		bkgHeight: '0rows'
	},
	controller: 'RxListCtl as vm',
	templateUrl: 'html/admin/rx/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.rx.create',
	url: '/create',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-rx' : 'icon-rx',
		title: 'New Pharmacy',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'admin.rx.list',
			msg: 'Return to Pharmacy List'
		}
	},
	controller: 'RxEditCtl as vm',
	templateUrl: 'html/admin/rx/ui/edit.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.rx.edit',
	url: '/update',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-rx' : 'icon-rx',
		title: 'Update Pharmacy',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'admin.rx.list',
			msg: 'Return to Pharmacy List'
		}
	},
	controller: 'RxEditCtl as vm',
	templateUrl: 'html/admin/rx/ui/edit.html?v=' + window.verityEspVersion,
	params: {
		RX: null
	}
});

routes.push({
	name: 'admin.rx.edit.customitem',
	url: '',
	routeInfo: null,
	views: {
		"WacNeutCustomItemView": {
			controller: 'WacNeutCustomItemCtl as vm',
			templateUrl: 'html/ops/customitem/ui/customitem.html?v=' + window.verityEspVersion
		}
	},
	params: {
		CE: null
	}
});

routes.push({
	name: 'admin.rx.edit.affs',
	url: '',
	routeInfo: null,
	views: {
		"affsChildView": {
			controller: 'AffsListCtl as vm',
			templateUrl: 'html/admin/affiliates/ui/aff.list.html?v=' + window.verityEspVersion
		}
	},
	params: {
		ViewType: 'RX',
		CE: null,
		RX: null
	}
});

routes.push({
	name: 'admin.rx.edit.affs-detail',
	url: '',
	routeInfo: null,
	views: {
		"affsChildView": {
			controller: 'AffsDetailCtl as vm',
			templateUrl: 'html/admin/affiliates/ui/aff.detail.html?v=' + window.verityEspVersion
		}
	},
	params: {
		ViewType: null,
		CE: null,
		RX: null
	}
});
 
 routes.push({
	name: 'admin.settings',
	abstract: true,
	url: '/settings',
	routeInfo: {
		icon: 'icon-monitor',
		title: 'Settings View'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main.flex.tpl.html'
		}
	}
});

routes.push({
	name: 'admin.settings.main',
	url: '/',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-monitor' : 'icon-monitor',
		title: 'Settings Viewer',
		bkgHeight: '1rows'
	},
	controller: 'AdminSettingsCtl as vm',
	templateUrl: 'html/admin/settings/ui/settings.main.html?v=' + window.verityEspVersion
});
 
 routes.push({
	name: 'admin.user',
	abstract: true,
	url: '/user',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'User Admin'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main' + window.espuiPrefs.skin + '.tpl.html'
		}
	},
});

routes.push({
	name: 'admin.user.list',
	url: '/list',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'User Admin',
		bkgHeight: '0rows'
	},
	controller: 'UserListCtl as vm',
	templateUrl: 'html/admin/user/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.user.list-review',
	url: '/list',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'User Admin',
		bkgHeight: '0rows'
	},
	controller: 'UserListCtl as vm',
	templateUrl: 'html/admin/user/ui/list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.user.list-customers',
	url: '/list',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'User Admin',
		bkgHeight: '0rows'
	},
	controller: 'UserListCtl as vm',
	templateUrl: 'html/admin/user/ui/customers.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.user.list-customers-review',
	url: '/list',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'User Admin',
		bkgHeight: '0rows'
	},
	controller: 'UserListCtl as vm',
	templateUrl: 'html/admin/user/ui/customers.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.user.create',
	url: '/create',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'New User',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'admin.user.list',
			msg: 'Return to User Admin'
		}
	},
	controller: 'UserEditCtl as vm',
	templateUrl: 'html/admin/user/ui/edit.html?v=' + window.verityEspVersion,
	params: {
		IsReview: false
	}
});

routes.push({
	name: 'admin.user.update',
	url: '/update',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'Update User',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'admin.user.list',
			msg: 'Return to User Admin'
		}
	},
	controller: 'UserEditCtl as vm',
	templateUrl: 'html/admin/user/ui/edit.html?v=' + window.verityEspVersion,
	params: {
		Id: null,
		IsReview: false
	}
});

routes.push({
	name: 'admin.user.myaccount',
	url: '/account',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'My Account',
		bkgHeight: '0rows'
	},
	controller: 'UserProfileCtl as vm',
	templateUrl: 'html/admin/user/ui/profile.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.user.mypreferences',
	url: '/preferences',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-users' : 'icon-users',
		title: 'My Preferences',
		bkgHeight: '0rows'
	},
	controller: 'UserPreferencesCtl as vm',
	templateUrl: 'html/admin/user/ui/preferences.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'admin.user.list.testing',
	url: '',
	routeInfo: null,
	views: {
		"userTestView": {
			controller: 'UserTestCtl as vm',
			templateUrl: 'html/admin/user/ui/test.html?v=' + window.verityEspVersion
		}
	}
});
 
 routes.push({
	name: 'orders',
	parent: 'espui',
	abstract: true,
	url: '/orders',
	routeInfo: {},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/mainB.tpl.html'
		}
	}
});

routes.push({
	name: 'orders.list',
	url: '/list',
	routeInfo: {
		icon: 'sprite-list',
		title: 'Order List',
		bkgHeight: '2rows'
	},
	controller: 'OrdersListCtl as vm',
	templateUrl: 'orders/ui/list.tpl.html'
});

routes.push({
	name: 'orders.new',
	url: '/new',
	routeInfo: {
		icon: 'sprite-orders',
		title: 'New Order Details',
		bkgHeight: '2rows'
	},
	controller: 'OrdersNewCtl as vm',
	templateUrl: 'orders/ui/new.tpl.html'
});

routes.push({
	name: 'orders.newsplit',
	url: '/newsplit',
	routeInfo: {
		icon: 'sprite-orders-split',
		title: 'New Split Order',
		bkgHeight: '1rows'
	},
	controller: 'OrdersNewSplitCtl as vm',
	templateUrl: 'html/orders/ui/newsplit.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'orders.edit',
	url: '/edit',
	routeInfo: {
		icon: 'sprite-orders-edit',
		title: 'Edit Order Details',
		bkgHeight: '2rows',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'orders.list',
			msg: 'Return to Order List'
		}
	},
	controller: 'OrdersNewCtl as vm',
	templateUrl: 'orders/ui/new.tpl.html',
	params: {
		id: null,
		breadcrumb: null
	}
});

routes.push({
	name: 'orders.presplit',
	url: '/presplit',
	routeInfo: {
		icon: 'sprite-orders-edit',
		title: 'Pre-Order Details',
		bkgHeight: '2rows',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'orders.list',
			msg: 'Return to Order List'
		}
	},
	controller: 'OrdersNewCtl as vm',
	templateUrl: 'orders/ui/new.tpl.html',
	params: {
		id: null,
		breadcrumb: null
	}
});

routes.push({
	name: 'orders.view',
	url: '/view',
	routeInfo: {
		icon: 'sprite-orders-edit',
		title: 'Order Details',
		bkgHeight: '2rows',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'orders.list',
			msg: 'Return to Order List'
		}
	},
	controller: 'OrdersNewCtl as vm',
	templateUrl: 'orders/ui/new.tpl.html',
	params: {
		id: null,
		breadcrumb: null
	}
});

routes.push({
	name: 'orders.place',
	url: '/placed',
	routeInfo: {
		icon: 'sprite-history',
		title: 'Placed Order Details',
		bkgHeight: '2rows',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'orders.list',
			msg: 'Return to Order List'
		}
	},
	controller: 'OrdersNewCtl as vm',
	templateUrl: 'orders/ui/new.tpl.html',
	params: {
		id: null,
		breadcrumb: null
	}
});

routes.push({
	name: 'orders.cancel',
	url: '/cancelled',
	routeInfo: {
		icon: 'sprite-history',
		title: 'Cancelled Order Details',
		bkgHeight: '2rows',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'orders.list',
			msg: 'Return to Order List'
		}
	},
	controller: 'OrdersNewCtl as vm',
	templateUrl: 'orders/ui/new.tpl.html',
	params: {
		id: null,
		breadcrumb: null
	}
});

routes.push({
	name: 'orders.splitdetail',
	url: '/splitdetail',
	routeInfo: {
		icon: 'sprite-orders-split',
		title: 'Split Order Details',
		bkgHeight: '2rows',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'orders.list',
			msg: 'Return to Order List'
		}
	},
	controller: 'OrdersSplitDetailCtl as vm',
	templateUrl: 'orders/ui/split.detail.tpl.html',
	params: {
		id: null,
		parentId: null,
		breadcrumb: null
	}
});

routes.push({
	name: 'orders.detail-route',
	url: '/orderdetail-route',
	routeInfo: {
		icon: 'sprite-orders',
		title: 'Order Details...',
		bkgHeight: '2rows'
	},
	controller: 'OrdersDetailRoute as vm',
	params: {
		id: null,
		breadcrumb: null
	}
}); 
 routes.push({
	name: 'invoice',
	parent: 'espui',
	abstract: true,
	url: '/invoice',
	routeInfo: {},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/mainB.tpl.html'
		}
	}
});

routes.push({
	name: 'invoice.review',
	url: '/review',
	routeInfo: {
		icon: 'sprite-invoice-review',
		title: 'Invoice Review List',
		bkgHeight: '4rows'
	},
	controller: 'InvoiceReviewCtl as vm',
	templateUrl: 'html/invoice/ui/review.list.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'invoice.review-detail',
	url: '/reviewdetail',
	routeInfo: {
		icon: 'sprite-invoice-review',
		title: 'Invoice Review Detail',
		bkgHeight: '2rows',
		breadcrumb: {
			icon: 'sprite-list',
			route: 'invoice.review',
			msg: 'Return to Invoice Review List'
		}
	},
	controller: 'InvoiceReviewDetailCtl as vm',
	templateUrl: 'html/invoice/ui/review.detail.html?v=' + window.verityEspVersion,
	params: {
		Id: null,
		tab: null
	}
});

routes.push({
	name: 'invoice.add',
	url: '/add',
	routeInfo: {
		icon: 'sprite-upload',
		title: 'Add Invoice',
		bkgHeight: '1rows'
	},
	controller: 'InvoiceManualCtl as vm',
	templateUrl: 'html/invoice/ui/manual.html?v=' + window.verityEspVersion,
	params: {
		order: false,
		breadcrumb: false
	}
});
 
 /**
 *    CE
 */

routes.push({
	name: 'report',
	parent: 'espui',
	abstract: true,
	url: '/report',
	routeInfo: {
		title: 'Report'
	},
	views: {
		"content@": {
			controller: 'MainCtl as vmMain',
			templateUrl: 'shared/main/main.report' + window.espuiPrefs.skin + '.tpl.html'
		}
	}
});

routes.push({
	name: 'report.ce',
	url: '/cecontract',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-ce' : 'icon-ce',
		title: 'Contract Pharmacy Report',
		bkgHeight: '3rows'
	},
	controller: 'ReportCtl as vm',
	templateUrl: 'html/report/ui/ce.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.cpfin',
	url: '/cpfinancial',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-ce' : 'icon-ce',
		title: 'CP Financial Report',
		bkgHeight: '3rows'
	},
	controller: 'ReportCtl as vm',
	templateUrl: 'html/report/ui/cpfin.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.cpfin.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});

routes.push({
	name: 'report.uds',
	url: '/uds',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-history' : 'icon-history',
		title: 'UDS Reporting',
		bkgHeight: '1rows'
	},
	controller: 'ReportUdsCtl as vm',
	templateUrl: 'html/report/ui/uds.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.uds.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});


/**
 *    RX
 */

routes.push({
	name: 'report.rx',
	url: '/rxcontract',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-rx' : 'icon-rx',
		title: 'Contract Pharmacy Report',
		bkgHeight: '3rows'
	},
	controller: 'ReportCtl as vm',
	templateUrl: 'html/report/ui/rx.html?v=' + window.verityEspVersion
});

/**
 *    BILLING
 */

routes.push({
	name: 'report.billing',
	abstract: true,
	url: '/billing'
});

routes.push({
	name: 'report.billing-rx',
	url: '/billing/rx',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-rx' : 'icon-rx',
		title: 'Pharmacy Invoice List Report',
		bkgHeight: '3rows'
	},
	controller: 'BillingRxCtl as vm',
	templateUrl: 'html/report/ui/billing.rx.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.billing-rxdetail',
	url: '/billing/rxdetail',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-rx' : 'icon-rx',
		title: 'Pharmacy Invoice Detail Report',
		bkgHeight: '2rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'report.billing-rx',
			msg: 'Return to Pharmacy Invoice List'
		}
	},
	controller: 'BillingRxDetailCtl as vm',
	templateUrl: 'html/report/ui/billing.rxdetail.html?v=' + window.verityEspVersion,
	params: {
		id: null,
		lineitemselected: null
	}
});

routes.push({
	name: 'report.billing-rxpdfbatch',
	url: '/billing/pdfbatch',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-rx' : 'icon-rx',
		title: 'Pharmacy Invoice PDF Batch',
		bkgHeight: '0rows',
		breadcrumb: {
			icon: window.espuiPrefs.skin == 'B' ? 'sprite-list' : 'icon-list',
			route: 'report.billing-rx',
			msg: 'Return to Pharmacy Invoice List'
		}
	},
	controller: 'BillingRxDetailCtl as vm',
	templateUrl: 'html/report/ui/billing.rxdetail.html?v=' + window.verityEspVersion,
	params: {
		pdfBatch: null
	}
});

routes.push({
	name: 'report.indigent',
	url: '/indigent',
	routeInfo: {
		icon: 'sprite-users',
		title: 'Indigent Claims',
		bkgHeight: '3rows'
	},
	controller: 'IndigentCtl as vm',
	templateUrl: 'html/report/ui/indigent.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.audit',
	url: '/audit',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-orders-review' : 'icon-monitor',
		title: 'Audit Report List',
		bkgHeight: '1rows'
	},
	controller: 'ReportAuditCtl as vm',
	templateUrl: 'html/report/ui/audit.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.wacneut',
	url: '/wacneutralizer',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-invoice-review' : 'glyphicon-adjust',
		title: 'WAC Neutralizer',
		bkgHeight: '3rows'
	},
	controller: 'WacNeutCtl as vm',
	templateUrl: 'html/report/ui/wacneut.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.findnpis',
	url: '/referralnpi',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-ops' : 'icon-ops',
		title: 'Referral NPI',
		bkgHeight: '0rows'
	},
	controller: 'ReportFindNpiCtl as vm',
	templateUrl: 'html/report/ui/findnpis.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.unreplenished',
	url: '/unreplenished',
	routeInfo: {
		icon: 'sprite-orders-backlog',
		title: 'Uninvoiced Items',
		bkgHeight: '0rows'
	},
	controller: 'UnreplenishedCtl as vm',
	templateUrl: 'html/report/ui/unreplenished.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.remittance',
	url: '/remittance',
	routeInfo: {
		icon: 'sprite-history',
		title: 'Remittance Report',
		bkgHeight: '1rows'
	},
	controller: 'RemittanceReportCtl as vm',
	templateUrl: 'html/report/ui/remittance.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.claimsubmission',
	url: '/claimsubmission',
	routeInfo: {
		icon: 'sprite-list',
		title: '340B Claims Submission',
		bkgHeight: '3rows'
	},
	controller: 'ClaimSubmissionCtl as vm',
	templateUrl: 'html/report/ui/claimsubmission.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.claimsubmission.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});

/**
 * 	SPLIT SAVINGS (OLD) and SPLIT FINANCIAL (NEW)
 */

routes.push({
	name: 'report.splitsavings',
	url: '/splitsavings',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-money' : 'icon-money',
		title: '340B Savings Report',
		bkgHeight: '3rows'
	},
	controller: 'SplitSaveCtl as vm',
	templateUrl: 'html/report/ui/splitsave.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.splitsavings.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});

routes.push({
	name: 'report.splitfinancial',
	url: '/splitfinancial',
	routeInfo: {
		icon: window.espuiPrefs.skin == 'B' ? 'sprite-orders-split' : 'icon-money',
		title: 'Facility Financial Report',
		bkgHeight: '3rows'
	},
	controller: 'SplitFinCtl as vm',
	templateUrl: 'html/report/ui/splitfin.html?v=' + window.verityEspVersion
});

routes.push({
	name: 'report.splitfinancial.async-reports',
	url: '',
	routeInfo: null,
	views: {
		"asyncReportsView": {
			controller: 'AsyncReportsCtl as vm',
			templateUrl: 'html/report/ui/async.reports.html?v=' + window.verityEspVersion
		}
	},
	params: {
		rptType: null,
		query: null
	}
});
 
 return routes;}